import { Box } from '@mui/material';
import { RiUploadCloud2Line } from '@remixicon/react';
import { useDropzone } from 'react-dropzone';
import { AgText } from 'src/components/ui';
import { useAiChatStore } from '../store/aiChat.store';

export default function AiChatDragAndDrop({ children }) {
  const addAttachedFiles = useAiChatStore((state) => state.addAttachedFiles);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles: File[]) => {
      addAttachedFiles(acceptedFiles);
    },
    noClick: true,
    noKeyboard: true,
    accept: {
      'application/pdf': ['.pdf'],
      'image/*': ['.png', '.jpg', '.jpeg', '.tiff', '.gif', '.bmp'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
      'text/csv': ['.csv'],
      'audio/*': ['.mp3', '.mp4', '.m4a', '.wav', '.flac', '.ogg', '.webm'],
    },
  });

  return (
    <Box {...getRootProps()}>
      <input {...getInputProps()} />
      {children}
      {isDragActive && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 9999,
            pointerEvents: 'none',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <RiUploadCloud2Line size={48} />
            <AgText size="h6" className="mt-2">
              Drop files here to upload
            </AgText>
            <AgText size="14" color="secondary">
              Supports PDF, images, Excel, CSV, and audio files
            </AgText>
          </Box>
        </Box>
      )}
    </Box>
  );
}
